import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { pushState } from 'redux-router';
import { Link } from 'react-router';
import DonationsSliderCard from './DonationsSliderCard';
import  Slider  from 'react-slick';

export class DonationsSlider extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {

    let settings = {
      autoplay: false,
      infinite: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      rtl: false
    };

    let browser = this.props.browser;

    if(browser.greaterThan.phablet) {
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    if(browser.greaterThan.tablet) {
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    if(browser.greaterThan.desktop) {
      settings.slidesToShow = 2;
      settings.slidesToScroll = 2;
    }

    let imgObjs;
    let imgList;
    let path = "/images/festival/donations/slider/slides/";

    imgObjs = [
      {
        url: 'Quotes_1.jpg'
      },
      {
        url: 'Quotes_2.jpg'
      },
      {
        url: 'Ticket_Page_1.jpg'
      },
      {
        url: 'Ticket_Page_2.jpg'
      },
      {
        url: 'Ticket_Page_3.jpg'
      },
    ];

    imgList = imgObjs.map((img, index) => {
      return <div data-slideindex={`slide-${index}`} key={`slide-${index}`}>
        <DonationsSliderCard
          imgUrl = {img.url}
          path = {path}
          browser = {browser}
        />
      </div>
    });

    return(
      <div>
        <Slider ref="slider" { ...settings }>{imgList}</Slider>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    Link,
  }
)(DonationsSlider);



// WEBPACK FOOTER //
// ./src/components/festival/donationsSlider/DonationsSlider.jsx